export default __webpack_public_path__ + "static/zon-the-go2-a576226f635e70e8e475a76e762f8526.png";